import { render } from "./SignupForm.vue?vue&type=template&id=63cc84dd&scoped=true"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"

import "./SignupForm.vue?vue&type=style&index=0&id=63cc84dd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63cc84dd"]])

export default __exports__